import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-contract-status',
    templateUrl: './contract-status.component.html',
    styleUrls: ['./contract-status.component.css']
})
export class ContractStatusComponent implements OnInit {
    @Input() currentStep: any = '';
    @Input() nextStep: any = '';
    @Input() processStatus: any = '';

    public useBullets: boolean = false;

    constructor() { }

    ngOnInit() {
        let barAmount: number = 0;
        if (this.processStatus.contractStatusProcess.bullet) {
            barAmount += 1;
        }
        if (this.processStatus.vodStatusProcess.bullet) {
            barAmount += 1;
        }
        if (this.processStatus.dlStatusProcess.bullet) {
            barAmount += 1;
        }
        if (barAmount > 1) {
            this.useBullets = true;
        } else {
            this.useBullets = false;
        }
    }

    onFileAdded(file: any) { }

    get titleClass() {
        if (
            this.processStatus.contractStatusProcess.customerRequiredFlag == 'RED' ||
            this.processStatus.vodStatusProcess.customerRequiredFlag == 'RED' ||
            this.processStatus.dlStatusProcess.customerRequiredFlag == 'RED'
        ) {
            return 'title-red';
        } else if (
            this.processStatus.contractStatusProcess.customerRequiredFlag == 'GRAY' ||
            this.processStatus.vodStatusProcess.customerRequiredFlag == 'GRAY' ||
            this.processStatus.dlStatusProcess.customerRequiredFlag == 'GRAY'
        ) {
            return 'title-gray';
        } else {
            return 'title-none';
        }
    }

    get showCustomerAccionRequired() {
        var show = this.processStatus.contractStatusProcess.customerRequiredFlag != 'GRAY' && this.processStatus.contractStatusProcess.customerRequiredFlag != 'NONE';
        show = show || this.processStatus.vodStatusProcess.customerRequiredFlag != 'GRAY' && this.processStatus.vodStatusProcess.customerRequiredFlag != 'NONE';
        show = show || this.processStatus.dlStatusProcess.customerRequiredFlag != 'GRAY' && this.processStatus.dlStatusProcess.customerRequiredFlag != 'NONE';
        show = show && !this.processStatus.info.processStatusComplete && !this.processStatus.info.declineWithoutOptions;
        return show;
    }

}
